import ServiceBase from './serviceBase';
import {
  TimelineContainer,
  MilestoneDateContainer,
  OperationMilestoneHistory,
} from './types/Timeline';

class OperTimelineService extends ServiceBase {
  getStages = async (operationId: number): Promise<TimelineContainer> =>
    this.get<TimelineContainer>(`OperationTimeline/${operationId}`);

  changeMilestoneDate = async (data: MilestoneDateContainer): Promise<void> =>
    this.post<void>('OperationTimeline/changeDate', data);

  getUserMilestonesEditHistory = async (
    operationId: number,
    milestoneId: number | null
  ): Promise<OperationMilestoneHistory[]> =>
    this.get<OperationMilestoneHistory[]>(
      `OperationTimeline/searchUserHistoryMilestones/${operationId}/${milestoneId}`
    );
}

const operTimelineService = new OperTimelineService();

export default operTimelineService;
